module.exports = __webpack_public_path__ + "static/media/life_corporation_logo.b200fa4a.png";